var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{ref:"psvdbg",staticStyle:{"width":"100vw","height":"calc(100vh - 60px)"},attrs:{"id":"viewer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }